import classNames from 'classnames';

export function SocialMediaIcons({
  network,
  fillColor = '#5C5F62',
}: {
  network: string;
  fillColor?: string;
}) {
  switch (network) {
    case 'facebook':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={classNames('w-6', 'h-6')}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 10.0615C20 4.50469 15.5229 0 10 0C4.47715 0 0 4.50469 0 10.0615C0 15.0835 3.65686 19.246 8.4375 20.0008V12.9699H5.89844V10.0615H8.4375V7.84483C8.4375 5.32317 9.93043 3.93028 12.2146 3.93028C13.3087 3.93028 14.4531 4.12679 14.4531 4.12679V6.60286H13.1921C11.9499 6.60286 11.5625 7.37845 11.5625 8.17413V10.0615H14.3359L13.8926 12.9699H11.5625V20.0008C16.3431 19.246 20 15.0835 20 10.0615Z"
            fill={fillColor}
          />
        </svg>
      );
    case 'twitter':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={classNames('w-6', 'h-6')}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.9525 6.04571C17.9647 6.22203 17.9647 6.39834 17.9647 6.57628C17.9647 11.9982 13.8371 18.2513 6.28966 18.2513V18.248C4.06013 18.2513 1.8769 17.6126 0 16.4085C0.324193 16.4475 0.65001 16.467 0.97664 16.4678C2.82429 16.4694 4.61913 15.8495 6.07272 14.7079C4.31688 14.6746 2.77717 13.5298 2.23928 11.8584C2.85436 11.9771 3.48812 11.9527 4.09181 11.7877C2.17753 11.401 0.800325 9.71908 0.800325 7.7658C0.800325 7.74793 0.800325 7.73087 0.800325 7.7138C1.37071 8.0315 2.00934 8.20781 2.6626 8.22731C0.859638 7.02235 0.30388 4.62382 1.39265 2.74854C3.47593 5.31202 6.54966 6.87041 9.84928 7.03535C9.51859 5.61021 9.97034 4.11681 11.0364 3.11498C12.689 1.56146 15.2882 1.64108 16.8418 3.29292C17.7607 3.11173 18.6415 2.77454 19.4475 2.29678C19.1412 3.24661 18.5001 4.05343 17.6437 4.56613C18.457 4.47025 19.2517 4.2525 20 3.92018C19.4491 4.74569 18.7552 5.46477 17.9525 6.04571Z"
            fill={fillColor}
          />
        </svg>
      );
    case 'instagram':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={classNames('w-6', 'h-6')}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.55556 2.22222H14.4444C16.2854 2.22222 17.7778 3.71461 17.7778 5.55556V14.4444C17.7778 16.2854 16.2854 17.7778 14.4444 17.7778H5.55556C3.71461 17.7778 2.22222 16.2854 2.22222 14.4444V5.55556C2.22222 3.71461 3.71461 2.22222 5.55556 2.22222ZM0 5.55556C0 2.48731 2.48731 0 5.55556 0H14.4444C17.5127 0 20 2.48731 20 5.55556V14.4444C20 17.5127 17.5127 20 14.4444 20H5.55556C2.48731 20 0 17.5127 0 14.4444V5.55556ZM16 5C16 5.55228 15.5523 6 15 6C14.4477 6 14 5.55228 14 5C14 4.44772 14.4477 4 15 4C15.5523 4 16 4.44772 16 5ZM10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z"
            fill={fillColor}
          />
        </svg>
      );
    case 'youtube':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={classNames('w-6', 'h-6')}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.8138 3.42103C18.6745 3.6527 19.3521 4.33533 19.5821 5.20212L19.582 5.20221C20 6.7733 20 10.0514 20 10.0514C20 10.0514 20 13.3293 19.582 14.9005C19.352 15.7673 18.6744 16.4499 17.8137 16.6817C16.2542 17.1026 9.99991 17.1026 9.99991 17.1026C9.99991 17.1026 3.74575 17.1026 2.18609 16.6817C1.32554 16.4498 0.647729 15.7673 0.41787 14.9004C0 13.3292 0 10.0513 0 10.0513C0 10.0513 0 6.77322 0.41787 5.20212C0.647729 4.33533 1.32554 3.6527 2.18617 3.42103C3.74583 3 10 3 10 3C10 3 16.2542 3 17.8138 3.42103ZM13.2051 10.0195L7.94872 13.0001V7.03857L13.2051 10.0195Z"
            fill={fillColor}
          />
        </svg>
      );
    case 'pinterest':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={classNames('w-6', 'h-6')}
        >
          <path
            fill={fillColor}
            d="M9.99178 0C4.47368 0 0 4.47368 0 9.99178C0 14.227 2.63158 17.8454 6.34868 19.301C6.25822 18.5115 6.18421 17.2944 6.38158 16.4309C6.5625 15.6497 7.54934 11.4638 7.54934 11.4638C7.54934 11.4638 7.25329 10.8635 7.25329 9.98355C7.25329 8.59375 8.05921 7.55757 9.0625 7.55757C9.91776 7.55757 10.3289 8.19901 10.3289 8.96382C10.3289 9.81908 9.78619 11.102 9.49836 12.2944C9.25987 13.2895 10 14.1036 10.9786 14.1036C12.7549 14.1036 14.1201 12.2286 14.1201 9.53125C14.1201 7.13816 12.4013 5.46875 9.94244 5.46875C7.09704 5.46875 5.42763 7.59868 5.42763 9.80263C5.42763 10.6579 5.75658 11.5789 6.16776 12.0806C6.25 12.1793 6.25822 12.2697 6.23355 12.3684C6.15954 12.6809 5.98684 13.3635 5.95395 13.5033C5.91283 13.6842 5.80592 13.7253 5.61678 13.6349C4.36678 13.051 3.58553 11.2336 3.58553 9.76151C3.58553 6.61184 5.87171 3.71711 10.1891 3.71711C13.6513 3.71711 16.3487 6.18421 16.3487 9.49013C16.3487 12.9359 14.1776 15.7072 11.1678 15.7072C10.1563 15.7072 9.2023 15.1809 8.88158 14.5559C8.88158 14.5559 8.37994 16.4638 8.25658 16.9326C8.03454 17.8043 7.42599 18.8898 7.0148 19.5559C7.9523 19.8438 8.93915 20 9.97533 20C15.4934 20 19.9671 15.5263 19.9671 10.0082C19.9836 4.47368 15.5099 0 9.99178 0Z"
          />
        </svg>
      );
    case 'snapchat':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={classNames('w-6', 'h-6')}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.9756 15.0291C19.8884 14.7412 19.4712 14.5382 19.4712 14.5382C19.4317 14.5175 19.3965 14.4989 19.3674 14.4844C18.672 14.1489 18.0555 13.745 17.5365 13.2873C17.1193 12.9186 16.7623 12.5126 16.4758 12.0818C16.125 11.5558 15.961 11.1167 15.8904 10.8785C15.851 10.7232 15.8572 10.661 15.8904 10.5803C15.9174 10.5119 15.9984 10.4477 16.0357 10.4166C16.2703 10.2509 16.6481 10.0065 16.8806 9.85742C17.0819 9.72693 17.2542 9.61509 17.3559 9.54467C17.6818 9.31684 17.906 9.08487 18.0368 8.83426C18.207 8.51116 18.2278 8.15493 18.0949 7.8049C17.9164 7.33268 17.4743 7.051 16.9117 7.051C16.7872 7.051 16.6585 7.0655 16.5298 7.09242C16.208 7.16284 15.9029 7.27675 15.6475 7.37617C15.6289 7.38445 15.6081 7.36996 15.6102 7.34925C15.6372 6.71754 15.6683 5.86837 15.5977 5.06269C15.5355 4.33364 15.3839 3.71851 15.139 3.18208C14.892 2.64358 14.5702 2.24591 14.319 1.95802C14.0803 1.68463 13.6589 1.28075 13.0237 0.918302C12.1311 0.408797 11.114 0.149902 10.0013 0.149902C8.89079 0.149902 7.87572 0.408797 6.98105 0.918302C6.30849 1.30147 5.87879 1.73434 5.68367 1.95802C5.4325 2.24591 5.11074 2.64358 4.86372 3.18208C4.6167 3.71851 4.46725 4.33157 4.40497 5.06269C4.33439 5.87251 4.36345 6.65334 4.39252 7.34925C4.39252 7.36996 4.37383 7.38445 4.35308 7.37617C4.09775 7.27675 3.79261 7.16284 3.47086 7.09242C3.34423 7.0655 3.21553 7.051 3.08891 7.051C2.52844 7.051 2.08629 7.33268 1.9057 7.8049C1.77285 8.15493 1.7936 8.51116 1.96382 8.83426C2.09667 9.08487 2.31878 9.31684 2.64469 9.54467C2.74432 9.61509 2.91869 9.72693 3.12005 9.85742C3.34631 10.0045 3.71373 10.2427 3.95037 10.4063C3.97943 10.427 4.07907 10.5015 4.11021 10.5803C4.14342 10.6631 4.14965 10.7252 4.10605 10.8909C4.0334 11.1312 3.86941 11.5661 3.52483 12.0818C3.23837 12.5147 2.88133 12.9186 2.46409 13.2873C1.94514 13.745 1.32862 14.1489 0.633228 14.4844C0.600015 14.501 0.560575 14.5196 0.519059 14.5444C0.519059 14.5444 0.103897 14.7557 0.0250163 15.0291C-0.0912289 15.433 0.218066 15.812 0.531513 16.015C1.04631 16.3464 1.67321 16.5245 2.03647 16.6218C2.13819 16.6487 2.22952 16.6736 2.31256 16.6984C2.36445 16.715 2.49523 16.7647 2.55127 16.8372C2.62185 16.9283 2.63016 17.0402 2.65506 17.1665C2.6945 17.3799 2.78376 17.6429 3.04739 17.8252C3.33801 18.024 3.70542 18.0385 4.17248 18.0571C4.6603 18.0758 5.26643 18.0986 5.96183 18.3284C6.28358 18.4341 6.57627 18.6143 6.91255 18.8214C7.61832 19.2543 8.49639 19.7928 9.99512 19.7928C11.4959 19.7928 12.3802 19.2522 13.0901 18.8172C13.4264 18.6122 13.715 18.4341 14.0305 18.3305C14.7259 18.1006 15.332 18.0778 15.8198 18.0592C16.2869 18.0406 16.6543 18.0281 16.9449 17.8272C17.2272 17.6325 17.3082 17.3426 17.3456 17.1251C17.3663 17.0174 17.3788 16.9201 17.441 16.8414C17.495 16.773 17.6154 16.7254 17.6715 16.7067C17.7566 16.6798 17.8521 16.655 17.9579 16.626C18.3212 16.5286 18.7779 16.4147 19.3321 16.102C20.0005 15.7229 20.0462 15.259 19.9756 15.0291Z"
            fill={fillColor}
          />
        </svg>
      );
    case 'patreon':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={classNames('w-6', 'h-6')}
        >
          <path
            fill={fillColor}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.52622 0V19.2461H0V0H3.52622ZM12.7857 0C16.7701 0 20 3.22995 20 7.21429C20 11.1986 16.7701 14.4286 12.7857 14.4286C8.80137 14.4286 5.57142 11.1986 5.57142 7.21429C5.57142 3.22995 8.80137 0 12.7857 0Z"
          />
        </svg>
      );
    case 'tiktok':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={classNames('w-6', 'h-6')}
        >
          <path
            d="M13.4829 0C13.8129 2.83809 15.3969 4.53015 18.151 4.71015V7.90226C16.555 8.05826 15.1569 7.53624 13.5309 6.55221V12.5224C13.5309 20.1067 5.26259 22.4767 1.93848 17.0406C-0.197588 13.5424 1.11045 7.40424 7.96268 7.15823V10.5243C7.44066 10.6083 6.88264 10.7403 6.37263 10.9144C4.84858 11.4304 3.98455 12.3964 4.22456 14.1005C4.68657 17.3646 10.6748 18.3306 10.1767 11.9524V0.00600019H13.4829V0Z"
            fill={fillColor}
          />
        </svg>
      );
    case 'shop':
      return (
        <svg
          width="32"
          height="32"
          viewBox="-1 -1 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={classNames('w-6', 'h-6')}
        >
          <path
            d="M1.043 1.502.61 4.082a.715.715 0 0 0 .41.771.73.73 0 0 0 .305.067h.648a1.095 1.095 0 0 0 .974-.598l.425-.842.424.842a1.083 1.083 0 0 0 .974.598h.832a1.095 1.095 0 0 0 .974-.598L7 3.48l.425.842a1.083 1.083 0 0 0 .973.598h.832a1.095 1.095 0 0 0 .974-.598l.424-.842.425.842a1.084 1.084 0 0 0 .974.598h.648a.73.73 0 0 0 .699-.529.716.716 0 0 0 .016-.31l-.433-2.579a1.078 1.078 0 0 0-.37-.646A1.093 1.093 0 0 0 11.883.6H2.117c-.258 0-.507.09-.704.256a1.078 1.078 0 0 0-.37.646ZM12.6 12.32V6.2H1.4v6.12c0 .286.113.561.315.764.201.202.474.316.76.316h2.138V8.6h4.774v4.8h2.139c.285 0 .558-.114.76-.316.2-.203.314-.478.314-.764Z"
            fill={fillColor}
          />
        </svg>
      );
    case 'linkedin':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={classNames('w-6', 'h-6')}
        >
          <path
            d="M15.8333 0H4.16667C1.86583 0 0 1.86583 0 4.16667V15.8333C0 18.1342 1.86583 20 4.16667 20H15.8333C18.135 20 20 18.1342 20 15.8333V4.16667C20 1.86583 18.135 0 15.8333 0ZM6.66667 15.8333H4.16667V6.66667H6.66667V15.8333ZM5.41667 5.61C4.61167 5.61 3.95833 4.95167 3.95833 4.14C3.95833 3.32833 4.61167 2.67 5.41667 2.67C6.22167 2.67 6.875 3.32833 6.875 4.14C6.875 4.95167 6.2225 5.61 5.41667 5.61ZM16.6667 15.8333H14.1667V11.1633C14.1667 8.35667 10.8333 8.56917 10.8333 11.1633V15.8333H8.33333V6.66667H10.8333V8.1375C11.9967 5.9825 16.6667 5.82333 16.6667 10.2008V15.8333Z"
            fill={fillColor}
          />
        </svg>
      );
    case 'email':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={classNames('w-6', 'h-6')}
        >
          <path
            d="M0 2.32443V12.5C0 13.3284 0.671573 14 1.5 14H18.5C19.3284 14 20 13.3284 20 12.5V2.32433L10.5038 7.86379C10.1924 8.04542 9.80741 8.04542 9.49605 7.86379L0 2.32443Z"
            fill={fillColor}
          />
          <path
            d="M19.4433 0.333666C19.1856 0.125 18.8574 0 18.5 0H1.5C1.14256 0 0.814324 0.125022 0.556631 0.333722L9.99992 5.84231L19.4433 0.333666Z"
            fill={fillColor}
          />
        </svg>
      );
    default:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={classNames('w-6', 'h-6')}
          viewBox="-234 36 30 30"
        >
          <path d="M-219 36c-8.3 0-15 6.7-15 15s6.7 15 15 15 15-6.7 15-15-6.7-15-15-15zm9.6 20c-.1.3-.6.7-2.5.9-.1 0-.2.2-.3.6 0 .1-.1.3-.1.4 0 .1-.1.2-.3.2-.1 0-.2 0-.4-.1-.3-.1-.7-.1-1.1-.1-.3 0-.5 0-.8.1-.5.1-1 .4-1.5.8-.7.5-1.4 1-2.6 1h-.2c-1.1 0-1.9-.5-2.6-1-.5-.3-1-.7-1.5-.8-.3 0-.5-.1-.8-.1-.5 0-.8.1-1.1.1-.2 0-.3.1-.4.1-.1 0-.2 0-.3-.2 0-.2-.1-.3-.1-.4-.1-.4-.1-.6-.3-.6-1.8-.3-2.3-.7-2.5-.9v-.1c0-.1.1-.2.2-.2 2.8-.5 4-3.3 4.1-3.4.2-.3.2-.6.1-.9-.2-.5-.8-.7-1.2-.8-.1 0-.2-.1-.3-.1-.8-.3-.9-.7-.9-.8.1-.3.4-.5.8-.5h.2c.4.2.7.3 1 .3.4 0 .6-.2.6-.2v-.6c-.1-1.3-.2-3 .2-3.9 1.3-2.8 3.9-3 4.7-3h.3c.8 0 3.5.2 4.7 3 .4.9.3 2.6.2 3.9v.6s.2.2.5.2.6-.1.9-.3c.1 0 .2-.1.3-.1.1 0 .2 0 .3.1.3.1.5.3.5.5s-.1.5-.9.8c-.1 0-.2.1-.3.1-.4.1-1 .3-1.2.8-.1.2-.1.5.1.9.1.1 1.3 3 4.1 3.4.1 0 .2.1.2.2.3 0 .3.1.2.1z" />
        </svg>
      );
  }
}
